const REFERRAL_TRIAL_SOURCE = "referral_trial";

interface AccessLevelLike {
  active?: boolean;
  source?: string | null;
}

interface PurchaseAccessLike {
  aiAccess?: AccessLevelLike;
}

export const hasUnlimitedAiMessages = (
  purchaseAccess?: PurchaseAccessLike
): boolean =>
  purchaseAccess?.aiAccess?.active === true &&
  purchaseAccess.aiAccess.source !== REFERRAL_TRIAL_SOURCE;
